export const numericEnumValueStrings = (enumObject) => new Set(Object.values(enumObject)
    .filter((enumValue) => typeof enumValue === 'number')
    .map(String));
//# sourceMappingURL=numeric-enum-value-strings.js.map